const ID_TOKEN_KEY = "id_token" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  // window.localStorage.clear();
  localStorage.removeItem("u_id")
  localStorage.removeItem("id_token")
  localStorage.removeItem("userInfo")
  localStorage.removeItem("typeLogin")
};

export default { getToken, saveToken, destroyToken };
